module.exports = __webpack_public_path__ + "static/media/rsvp_main_iphone.6663c10c.png";